import { ListApiResponse } from '../types/apiResponse';
import {
  AddAnnouncementViewModel,
  AnnouncementItemDto,
  AnnouncementViewModel,
  IdResponse,
  StatusResponse,
} from '../types/swagger-dtos/AnnouncementsDtos';
import {
  apiUrl,
  getList,
  deleteRecord,
  getSingleRecord,
  saveRecord,
  apiOptions,
  handleError,
  handleResponse,
  exportData,
} from './apiUtils';
import type { ApiListParams } from '../types/api/listParams';
const baseUrl = apiUrl + '/announcements/';

export function getAnnouncements(params?: ApiListParams): Promise<ListApiResponse<AnnouncementItemDto>> {
  return getList(`${baseUrl}search`, params);
}
export function getAllAnnouncements(): Promise<AnnouncementItemDto[]> {
  return fetch(`${baseUrl}`, apiOptions())
    .then(handleResponse)
    .catch(handleError);
}

export function getAnnouncementById(id: string): Promise<AnnouncementViewModel> {
  return getSingleRecord<AnnouncementViewModel>(baseUrl, id);
}

export function saveAnnouncement(
  announcement: AddAnnouncementViewModel
): Promise<StatusResponse> {
  return saveRecord(baseUrl, announcement);
}

export function deleteAnnouncement(id: string): Promise<IdResponse> {
  return deleteRecord(baseUrl, id);
}

export function exportAnnouncementsData(params: import('../types/api/listParams').ApiExportParams): Promise<void> {
  return exportData(`${apiUrl}/export/announcements/search`, 'announcementDate', params);
}
